import type { AccordionItem } from "components/Accordion";
import type { ISbRichtext } from "storyblok-js-client";
import type { SerializedHelpQuestion } from "utils/serverSideUtils/getHelpQuestionsByCategory";

const serializeAccordionItems = (data: SerializedHelpQuestion[]): AccordionItem[] =>
  data.map((question) => {
    const header: ISbRichtext & { type: string } = {
      type: "doc",
      content: [{ type: "paragraph", content: [{ text: question.content.question, type: "text" }] }],
    };

    return {
      _uid: question.content._uid,
      body: question.content.answer,
      header,
    };
  });

export default serializeAccordionItems;
